import { useSelector } from 'react-redux';
import { UserPermission } from 'src/services/users/userPermissions';
import { AppState } from 'src/store/Store';

export const usePermissions = (permission: string) => {
  const permissions = useSelector((state: AppState) => state.permissionsReducer.permissions);
  if (permissions?.length) {
    return permissions?.some((perm: UserPermission) => perm?.name === permission);
  } else {
    return false;
  }
};
